"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EditSensorComponent = _interopRequireDefault(require("../components/EditSensorComponent"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _helper = require("../common_features/utility/helper");
var _WebSocketManager = _interopRequireDefault(require("../common_features/utility/WebSocketManager"));
var _awsAmplify = require("aws-amplify");
var _event = require("../common_features/utility/event");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditSensor = () => {
  var _gateways$;
  const timeOutRef = (0, _react.useRef)(null);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [sensorEstablished, setSensorEstablished] = (0, _react.useState)(false);
  const [openErrorModal, setOpenErrorModal] = (0, _react.useState)(false);
  const [socketLoader, setSocketLoader] = (0, _react.useState)(false);
  const [warningModal, setWarningModal] = (0, _react.useState)(false);
  const {
    selectedAccessory
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateways
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const sensorPayload = {
    action: "readRequest",
    request: {
      name: "end_node_deprovisioning",
      gatewayId: (_gateways$ = gateways[0]) === null || _gateways$ === void 0 ? void 0 : _gateways$.deviceId,
      deviceId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId,
      token: ""
    }
  };
  const warningModalData = {
    variant: "warning-modal",
    displayModal: warningModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Warning",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "Removing the Sensor will remove all alerts and notifications. You will  not lose any historical data previously collected.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleFailureContinue(),
    negativeAvtion: () => handlefailureCancel()
  };
  const deleteErrorModalData = {
    variant: "error-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Error",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "The requested action did not complete successfully, please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleDeleteErrorRetry(),
    negativeAvtion: () => handleDeleteErrorCancel()
  };
  const handleDeleteErrorRetry = () => {
    setOpenErrorModal(false);
    handleClick();
  };
  const handleDeleteErrorCancel = () => {
    setOpenErrorModal(false);
  };
  const handleFailureContinue = () => {
    setWarningModal(false);
    handleClick();
  };
  const handlefailureCancel = () => {
    setWarningModal(false);
  };
  const handleBackToStore = () => {
    navigate(-1);
  };
  const handleMoveSensorBtn = () => {
    navigate(_RoutePath.default.editSensorPlacement.useLink);
  };
  const handleRemoveSensorBtn = () => {
    setWarningModal(true);
  };
  (0, _react.useImperativeHandle)(timeOutRef, () => ({
    onTimeout: () => {
      if (!sensorEstablished) {
        setOpenErrorModal(true);
        setSocketLoader(false);
      }
    }
  }));
  const handleSensorTimeout = () => {
    setTimeout(() => {
      var _timeOutRef$current;
      return timeOutRef === null || timeOutRef === void 0 ? void 0 : (_timeOutRef$current = timeOutRef.current) === null || _timeOutRef$current === void 0 ? void 0 : _timeOutRef$current.onTimeout();
    }, 300000);
  };
  const handleClick = async () => {
    setSocketLoader(true);
    const payloadObj = {
      ...sensorPayload
    };
    const token = (await _awsAmplify.Auth.currentSession()).getAccessToken().getJwtToken();
    payloadObj.request.token = token;
    const obj = {
      ...payloadObj,
      request: JSON.stringify(payloadObj.request)
    };
    handleSensorTimeout();
    _WebSocketManager.default.getInstance().connect().sendEvent(obj);
    _event.eventEmitter.subscribe("socketOnMessage", data => {
      if (data.response.data.payload.status === "command_received") {
        setSocketLoader(false);
        setSensorEstablished(true);
        navigate(-1);
      } else if (data.response.data.payload.status === "error") {
        setSocketLoader(false);
        setSensorEstablished(false);
        setOpenErrorModal(true);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_EditSensorComponent.default, {
    handleBack: handleBackToStore,
    leftArrow: _index.default.leftArrow.default,
    backNavigationScreen: "System Dashboard",
    editSensorText: "Edit Sensor",
    pname: "".concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber, ">").concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppModelNumber, ">").concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppPlacement),
    subText: "Are you making any changes to this sensor?",
    installationDateText: "Installation Date",
    moveSensorButtonText: "Move Sensor",
    installationDate: (0, _helper.getDate)(selectedAccessory.refAppInstallationDate),
    serialNumberText: "Serial Number",
    serialNumber: selectedAccessory.refAppPartNumber,
    sensorImage: selectedAccessory.refAppImageUrl,
    removeSensorButtonText: "Remove Sensor",
    onClickMoveSensor: handleMoveSensorBtn,
    onClickRemoveSensor: handleRemoveSensorBtn,
    warningSensorModalData: warningModal ? warningModalData : deleteErrorModalData,
    warningModal: warningModal,
    socketLoader: socketLoader,
    openErrorModal: openErrorModal
  });
};
var _default = exports.default = EditSensor;